import { HStack, Text, Icon } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import { SuggestionsButton } from '~/components/ui/tabs/Button';
import { SuggestionsButtonList } from '~/components/ui/tabs/ButtonList';
import { StyledTab } from '~/components/ui/tabs/StyledTab';
import { ICONS } from '~/constants/icons';
import { useUserAction } from '~/hooks/useUserAction';
import { useUser } from '~/hooks/useUser';
import { getHomebuyerIcon } from '~/lib/providers/supabase';
import { useParams, useRouter } from 'next/navigation';
import { getSpeculatorPath } from '@habity/services';
import { ROUTES } from '@habity/constants';

export const SearchProfilesTab = () => {
  const t = useTranslations('HomesList.Tabs.Homebuyers');

  return (
    <StyledTab>
      <HStack>
        <Icon as={ICONS.TABS.DEFAULT.SEARCH_PROFILES} />
        <Text>{t('title')}</Text>
      </HStack>
    </StyledTab>
  );
};

export const SearchProfilesTabContent = () => {
  const { user } = useUser();
  const { push } = useRouter();
  const params = useParams();
  const { searchId } = params || {};

  const { executeAction } = useUserAction();

  const t = useTranslations('HomesList.Tabs.Homebuyers');
  const { searches } = user || {};

  return (
    <SuggestionsButtonList>
      {user &&
        searches &&
        searches.map((h, index) => {
          const categoryIcon = getHomebuyerIcon(h);
          return (
            <SuggestionsButton
              key={index}
              icon={categoryIcon || ICONS.HOMEBUYERS_ALERT}
              label={h.title || ''}
              isActive={!!(searchId && Number(searchId) === h.id)}
              onClick={() => push(getSpeculatorPath(h))}
            />
          );
        })}
      <SuggestionsButton
        key={'add-homebuyer'}
        icon={ICONS.ADD_HOMEBUYERS}
        label={t('Buttons.addNew')}
        onClick={() => {
          executeAction({
            action: 'created_search_profile',
            redirectTo: ROUTES.BUY,
          });
        }}
      />
    </SuggestionsButtonList>
  );
};
